export default __webpack_public_path__ + "static/media/InvalidAadhaar.0bacbf53.svg";